export default __webpack_public_path__ + "i18n/translations/translation-id.8e3ce52c.json";